import React from "react";
import { ZERO_REFERENCE_LINE } from "../constants";
import Helpers from "../../../services/helpers";
import { OPTIONS_BY_CHART } from "./constants";
import { usePopularChartContext } from "../../contexts/popularchartcontext";

const PopularCardTooltip = ({ payload, label }) => {
  const { selectedGraph } = usePopularChartContext();

  const items = [];

  if (!payload) {
    return null;
  }

  payload.map((entry) => {
    const { dataKey, value } = entry;
    if (value !== -1 && dataKey.indexOf("_trend") === -1 && dataKey !== ZERO_REFERENCE_LINE) {
      items.push(entry);
    }
  });

  if (!items.length) {
    return null;
  }

  items.sort(Helpers.sortByFieldName("value")).reverse();

  return (
    <div className={"recharts-default-tooltip tooltipContainer"} style={{}}>
      <div className={"tooltipLabel"}>
        <b className={"recharts-tooltip-label"}>{label}</b>
      </div>
      <ul className={"recharts-tooltip-item-list tooltipList"}>
        {items.map((entry, index) => {
          const cardId = entry.dataKey.split("_")[0];
          return (
            <li className={"recharts-tooltip-item tooltipListItem"} data-key={entry.dataKey} key={`item-${index}`}>
              <div className={"tooltipHighlightBar"} style={{ backgroundColor: entry.color }} />
              <div className={"tooltipDataContainer"}>
                <div>
                  <span className={"recharts-tooltip-item-name"}>{entry.name}</span>
                </div>
                <div className={"tooltipValuesContainer"}>
                  <b className={"recharts-tooltip-item-value tooltipHighlightedValue"} style={{ color: entry.color }}>
                    {entry.payload[`${cardId}_count`]} Sales
                  </b>

                  <b className={"recharts-tooltip-item-value tooltipHighlightedValue"} style={{ color: entry.color }}>
                    Avg:{" "}
                    {OPTIONS_BY_CHART[selectedGraph].tooltipEntryValueFormatter(
                      entry.value,
                      entry.payload,
                      entry.dataKey,
                    )}
                  </b>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PopularCardTooltip;
